import { createSelector } from 'reselect';

const authToken = auth => {
  const { token } = auth;
  return token;
};

export default createSelector(state => state.auth, authToken);
